import {
  differenceInDays,
  differenceInMinutes,
  format,
  formatRelative,
  isFuture,
  isPast,
  isThisYear,
  isToday,
  isYesterday,
  startOfToday,
} from 'date-fns';
import { t } from 'i18next';
import { MatrixEvent, MsgType } from 'matrix-js-sdk/src';

export const formatTimestampToDateConversations = (dateTime: number) => {
  const date = new Date(dateTime);

  if (isToday(date)) return format(date, 'HH:mm');
  if (isYesterday(date)) {
    const yesterdayDate = formatRelative(date, new Date());

    return yesterdayDate.slice(0, 1).toLocaleUpperCase() + yesterdayDate.slice(1);
  }

  const daysDifference = differenceInDays(startOfToday(), date);
  const isMoreThanAWeekAgo = daysDifference > 7;
  const isMoreThanAWeekAhead = daysDifference < -7;

  if ((isPast(date) && !isMoreThanAWeekAgo) || (isFuture(date) && !isMoreThanAWeekAhead)) {
    return format(date, 'eee HH:mm');
  }

  return isThisYear(date) ? format(date, 'MM-dd') : format(date, 'dd-MM-yyyy');
};

export const getIsMessagesFarApart = (m1: number, m2: number) =>
  Math.abs(differenceInMinutes(new Date(m1), new Date(m2))) >= 2;

export const getFormattedGuestDisplayName = (name?: string) =>
  !name || /^@[a-zA-Z0-9._=-]+:[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(name) ? t('participant') : name;

export const formatEventId = (eventId?: string) => 'id-' + eventId?.replace(/\$/g, '');

export const getIsMediaEvent = (matrixEvent: MatrixEvent) =>
  [MsgType.File, MsgType.Image, MsgType.Audio, MsgType.Video].includes(matrixEvent.getContent().msgtype as MsgType);
